module.exports = __webpack_public_path__ + "img/onboarding/elevio-icon-6b5e9cb7ee7e75cba3d35e6de33d7783.png";